<div role="tablist" class="aa-tabgroup" [ngClass]="customCls" [class.justified]="justified">
    <div *ngFor="let tab of tabs" #tabRefs class="aa-tab" [class.disabled]="tab.disabled" [class.active]="tab.active"
        [class.popup]="!tab.tabRoute">
        <div class="aa-tab-title">
            <a *ngIf="tab.tabRoute; else noLink" [routerLink]="tab.tabRoute" [queryParams]="tab.queryParams"
                (click)="$event.stopPropagation()">
                {{ tab.title }}
                <ng-template [ngTemplateOutlet]="tab.titleTpl?.templateRef"></ng-template>
            </a>
            <ng-template #noLink>
                <span (click)="onClickTab(tab)">
                    {{ tab.title }}
                    <ng-template [ngTemplateOutlet]="tab.titleTpl?.templateRef"></ng-template>
                </span>
            </ng-template>
            <em *ngIf="tab.subTabItems" class="fal fa-chevron-double-down"></em>
            <span class="new-ribbon-tab" *ngIf="tab.soon">
                {{ "LAYOUT.MENU.RIBBON.SOON" | translate }}
            </span>
            <span class="new-ribbon-tab" *ngIf="tab.nuovo">
                {{ "LAYOUT.MENU.RIBBON.NUOVO" | translate }}
            </span>
        </div>
        <div class="aa-tab-border"></div>
    </div>
</div>
<div class="aa-tab-content">
    <ng-container *ngFor="let tab of tabs">
        <div role="tabpanel" [attr.aria-labelledby]="tab.id" id="{{ tab.id }}-panel" *ngIf="tab.active">
            <ng-template [ngTemplateOutlet]="tab.contentTpl?.templateRef"></ng-template>
        </div>
    </ng-container>
</div>